(function(){
  function isRenvoi(el){
    var tg=(el.tagName||"").toLowerCase();
    var st=(el.getAttribute("style")||"").toLowerCase();
    var hasLink=!!el.querySelector("a");
    if(tg==="div"&&st.indexOf("f06e69")!==-1&&st.indexOf("border")!==-1)return true;
    if(tg==="div"&&st.indexOf("f5f8f3")!==-1&&st.indexOf("d4e0cc")!==-1)return true;
    if(tg==="div"&&st.indexOf("fafafa")!==-1&&hasLink&&st.indexOf("f06e69")===-1)return true;
    if(tg==="p"&&st.indexOf("ovo")!==-1&&hasLink)return true;
    if(tg==="p"&&hasLink){
      var links=Array.from(el.querySelectorAll("a"));
      var cross=links.some(function(a){
        var h=a.getAttribute("href")||"";
        return h.indexOf("/products/")!==-1||h.indexOf("/collections/")!==-1;
      });
      if(cross&&(el.textContent||"").trim().length<280)return true;
    }
    return false;
  }
  function norm(s){
    return (s||"").normalize("NFD").replace(/[̀-ͯ]/g,"").toLowerCase();
  }
  function findCaracHeading(scope){
    var hs=scope.querySelectorAll("h2,h3");
    for(var i=0;i<hs.length;i++){
      var t=norm(hs[i].textContent).trim();
      if(t.indexOf("caract")!==-1||t.indexOf("specif")!==-1)return hs[i];
    }
    return null;
  }
  function isEmptyEl(el){
    var tg=(el.tagName||"").toLowerCase();
    if(tg==="style"||tg==="script")return true;
    if(el.querySelector&&el.querySelector("img,svg,iframe"))return false;
    return (el.textContent||"").replace(/ /g," ").trim().length===0;
  }
  function injectCSS(){
    if(document.getElementById("zy-custom-css"))return;
    var stl=document.createElement("style");
    stl.id="zy-custom-css";
    stl.textContent=".zy-intro-visible{margin:4px 0 20px;font-size:15px;line-height:1.7;color:#333;}.zy-intro-visible p{margin:0;}"
      +".zy-tiroir__ico{border:0!important;border-radius:0!important;width:auto!important;height:auto!important;min-width:0!important;font-size:0!important;color:#F06E69!important;transition:none!important;}"
      +".zy-tiroir__ico::after{content:'+';font-size:26px;font-weight:400;line-height:1;color:#F06E69;}"
      +"details[open]>.zy-tiroir__hd>.zy-tiroir__ico{transform:none!important;}"
      +"details[open]>.zy-tiroir__hd>.zy-tiroir__ico::after{content:'−';}"
      +".zy-faq>h2{padding-left:14px;}"
      +".zy-faq .zy-tiroir__hd{padding-left:14px!important;}"
      +".zy-faq__a{padding:10px 0 4px 14px!important;font-size:14px;line-height:1.7;color:#444;}";
    document.head.appendChild(stl);
  }
  function styleFaq(){
    var hs=document.querySelectorAll("h2");
    var section=null;
    for(var i=0;i<hs.length;i++){
      if(norm(hs[i].textContent).indexOf("questions frequentes")!==-1){section=hs[i].parentNode;break;}
    }
    if(!section)return;
    section.classList.add("zy-faq");
    var dets=section.querySelectorAll("details");
    dets.forEach(function(d,idx){
      d.classList.add("zy-tiroir");
      d.removeAttribute("style");
      if(idx===dets.length-1)d.classList.add("zy-tiroir-last");
      var sum=d.querySelector("summary");
      if(sum){
        sum.classList.add("zy-tiroir__hd");
        sum.removeAttribute("style");
        var spans=sum.querySelectorAll("span");
        if(spans.length){
          var ico=spans[spans.length-1];
          ico.classList.add("zy-tiroir__ico");
          ico.removeAttribute("style");
        }
      }
      Array.from(d.children).forEach(function(c){
        if((c.tagName||"").toLowerCase()==="p"){c.classList.add("zy-faq__a");c.removeAttribute("style");}
      });
    });
  }
  function liftIntro(dBd){
    var wrap=document.querySelector(".zy-tiroirs");
    if(!wrap||!wrap.parentNode)return;
    var kids=Array.from(dBd.children);
    var target=null;
    for(var i=0;i<kids.length;i++){
      var el=kids[i];
      if(isEmptyEl(el))continue;
      if((el.tagName||"").toLowerCase()!=="p")continue;
      if(isRenvoi(el))continue;
      var txt=(el.textContent||"").replace(/ /g," ").trim();
      if(txt.length<20)continue;
      target=el;break;
    }
    if(!target)return;
    var intro=document.createElement("div");
    intro.className="zy-intro-visible";
    intro.appendChild(target);
    wrap.parentNode.insertBefore(intro,wrap);
  }
  function init(){
    injectCSS();
    styleFaq();
    var dDet=document.getElementById("zy-tiroir-desc");
    if(!dDet)return;
    var dBd=dDet.querySelector(".zy-tiroir__bd");
    if(!dBd)return;
    liftIntro(dBd);
    var cDet=document.getElementById("zy-tiroir-carac");
    var cBd=document.getElementById("zy-carac-bd");
    if(cDet&&cBd){
      var ch=findCaracHeading(dBd);
      if(ch){
        var moved=[ch];
        var sib=ch.nextElementSibling;
        while(sib){
          var tg=(sib.tagName||"").toLowerCase();
          if(tg==="h2"||tg==="h3")break;
          var next=sib.nextElementSibling;
          moved.push(sib);
          sib=next;
        }
        moved.forEach(function(e){cBd.appendChild(e);});
        cDet.style.display="";
      }else{cDet.style.display="none";}
    }
    var hors=document.querySelector(".zy-hors-tiroir");
    if(!hors)return;
    Array.from(dBd.querySelectorAll(".zy-bp")).forEach(function(e){hors.appendChild(e);});
    function scan(scope){
      Array.from(scope.children).forEach(function(el){
        if(isRenvoi(el)){hors.appendChild(el);}
      });
    }
    scan(dBd);
    Array.from(dBd.children).forEach(function(el){
      if((el.tagName||"").toLowerCase()==="div"&&!isRenvoi(el)){scan(el);}
    });
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",init);
  }else{
    init();
  }
})();
